import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        modelValue: _ctx.isValidWorkspace,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isValidWorkspace) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    "data-cy": "accountingWorkspace-name",
                    modelValue: _ctx.accountingWorkspace.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingWorkspace.name) = $event)),
                    label: "Nom",
                    outlined: "",
                    rules: [(v) => !!v || 'Un nom est requis'],
                    readonly: !_ctx.enableWrite,
                    density: "compact"
                  }, null, 8, ["modelValue", "rules", "readonly"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "3",
            style: {"border-right":"1px #eaeaea solid"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                nav: "",
                density: "compact",
                selected: _ctx.selectedMenu,
                "onUpdate:selected": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedMenu) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    link: "",
                    value: "available-companies",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedMenu('available-companies'))),
                    id: "Societe"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("$fa-building")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createElementVNode("span", { class: "subtitle-2" }, "Sociétés affectées", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    link: "",
                    value: "available-workspace-users",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectedMenu('available-workspace-users')))
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { size: "small" }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("$fa-user")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createElementVNode("span", { class: "subtitle-2" }, "Utilisateurs affectés", -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["selected"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "9",
            class: "pl-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window, {
                modelValue: _ctx.selectedMenu,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedMenu) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: "available-companies" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                "data-cy": "accountingWorkspace-search",
                                modelValue: _ctx.searchCompany,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchCompany) = $event)),
                                label: "Rechercher",
                                outlined: "",
                                "hide-details": "",
                                density: "compact"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.filteredClientCompanies.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.isFromUsersMenu
                                        ? "Aucune société trouvée"
                                        : "Aucun dossier trouvé"), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                elevation: "0",
                                class: "mr-2",
                                rounded: "",
                                readonly: !_ctx.enableWrite,
                                size: "small",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectAllCompany()))
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode(" Sélectionner tous les dossiers ")
                                ])),
                                _: 1
                              }, 8, ["readonly"]),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                elevation: "0",
                                rounded: "",
                                readonly: !_ctx.enableWrite,
                                size: "small",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.diselectAllCompany()))
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode(" Désélectionner tous les dossiers ")
                                ])),
                                _: 1
                              }, 8, ["readonly"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredClientCompanies, (comp) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              cols: "6",
                              key: comp.id,
                              class: "pr-2 pb-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_v_list_item, {
                                    ripple: "",
                                    class: "oss-list-item",
                                    "data-cy": "accountingWorkspace-item"
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        "data-cy": "accountingWorkspace-itemCheckbox",
                                        modelValue: _ctx.selectedClientCompanies,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedClientCompanies) = $event)),
                                        readonly: !_ctx.enableWrite,
                                        value: comp.id
                                      }, null, 8, ["modelValue", "readonly", "value"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { "data-cy": "accountingWorkspace-title" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(comp.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: "available-workspace-users" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "8",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field_filled, {
                                modelValue: _ctx.searchUser,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchUser) = $event)),
                                label: "Rechercher",
                                outlined: "",
                                "hide-details": "",
                                density: "compact",
                                "append-inner-icon": "$search",
                                clearable: "",
                                "onClick:clear": _cache[10] || (_cache[10] = ($event: any) => (_ctx.searchUser = ''))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pt-2"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.filteredWorkspaceUsers.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" Aucun utilisateur trouvé ")
                              ], 64))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                elevation: "0",
                                class: "mr-2",
                                rounded: "",
                                readonly: !_ctx.enableWrite,
                                size: "small",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectAllUsers()))
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode(" Sélectionner tous les utilisateurs ")
                                ])),
                                _: 1
                              }, 8, ["readonly"]),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                elevation: "0",
                                rounded: "",
                                readonly: !_ctx.enableWrite,
                                size: "small",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.diselectAllUsers()))
                              }, {
                                default: _withCtx(() => _cache[22] || (_cache[22] = [
                                  _createTextVNode(" Désélectionner tous les utilisateurs ")
                                ])),
                                _: 1
                              }, 8, ["readonly"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredWorkspaceUsers, (user) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              cols: "6",
                              key: user.id,
                              class: "pr-2 pb-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  ripple: "",
                                  class: "oss-list-item",
                                  "two-line": ""
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.selectedWorkspaceUsers,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedWorkspaceUsers) = $event)),
                                      readonly: !_ctx.enableWrite,
                                      value: user.id
                                    }, null, 8, ["modelValue", "readonly", "value"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.getUserDisplayName(user)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_list_item_subtitle, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(user.email), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}